import { StripeApiRequestBodyType } from "@intelligems/ig-types";
import { invalidateOrganizationSummary } from "@src/api/organization-summaries/invalidate-organization-summary";
import { adminKeys, organizationsKeys } from "@src/api/queryKeys";
import {
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import { api } from "../api";

const stripeApi = async <Response>(data: StripeApiRequestBodyType) => {
  const resp = await api.post<Response>(`/v2/stripe/api`, data);
  return resp.data;
};

export const useStripeApi = <Response>(
  data: StripeApiRequestBodyType,
  enabled = true
) => {
  return useQuery<Response, Error>({
    queryKey: [{ scope: "stripeApi", action: data }],
    queryFn: async () => stripeApi<Response>(data),
    enabled: !!(data.orgs?.length && enabled),
  });
};
export const useQueriesStripeApi = <Response>(
  data: StripeApiRequestBodyType[],
  enabled = true
) => {
  return useQueries({
    queries: data.map((data) => ({
      queryKey: [{ scope: "stripeApi", action: data }],
      queryFn: async () => stripeApi<Response>(data),
      enabled: !!(data.orgs?.length && enabled),
    })),
  });
};

export const usePostStripeApi = <Response>() => {
  const queryClient = useQueryClient();
  return useMutation<Response, Error, StripeApiRequestBodyType>({
    mutationKey: ["postStripeApi"],
    mutationFn: async (data: StripeApiRequestBodyType) =>
      stripeApi<Response>(data),
    onSuccess: async (data, variables, context) => {
      await invalidateOrganizationSummary(queryClient, variables.orgs);
      void queryClient.invalidateQueries({ queryKey: adminKeys.agencies });

      if (variables.action === "createCustomer") {
        void queryClient.invalidateQueries({
          queryKey: [
            { scope: "stripeApi", action: { action: "getAllCustomers" } },
          ],
        });
        return;
      }
    },
  });
};
